import { State } from "common/types/redux";

import {
  premiumCanBeUpgraded,
  premiumHasAccessToTutoring
} from "seneca-common/features/subscriptions/features/subscription/selectors";
import {
  hasLiveSubscription,
  hasSubscriptionWithFailedPayment
} from "seneca-common/features/subscriptions/state";

import { isPlurallApp } from "features/plurall";
import { getShowPremiumAds } from "features/regions/selectors";

export function getSellUpgradeToUser(state: State) {
  if (!getShowPremiumAds(state)) {
    return false;
  }

  if (hasSubscriptionWithFailedPayment(state)) return false;

  if (premiumHasAccessToTutoring(state)) {
    return false;
  }

  if (premiumCanBeUpgraded(state)) {
    return true;
  }

  return false;
}

export function getSellPremiumToUser(state: State) {
  return (
    !hasLiveSubscription(state) && (isPlurallApp() || getShowPremiumAds(state))
  );
}
